import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Mehrfachauswahl, ersetzt Chosen. Optionen per data-tom-select-options-value
// (JSON).
//
// Turbo legt vor dem Seitenwechsel einen Schnappschuss der Seite in den Cache,
// bevor Stimulus disconnect aufruft. Ohne Abbau vor turbo:before-cache enthielte
// der Schnappschuss die fertige Tom-Select-Hülle, und beim Zurückblättern käme
// eine zweite dazu. Deshalb baut der Controller dort und in disconnect ab.
export default class extends Controller {
  static values = { options: Object }

  connect() {
    this.teardown = this.teardown.bind(this)
    document.addEventListener("turbo:before-cache", this.teardown)
    this.tomSelect = new TomSelect(this.element, {
      plugins: this.element.multiple ? ["remove_button"] : [],
      maxOptions: null,
      ...this.optionsValue,
    })
    // Die Beschriftung zeigt jetzt auf das Eingabefeld von Tom Select; das
    // native Select bleibt nur für das Formular und ist für Screenreader doppelt.
    this.element.setAttribute("aria-hidden", "true")
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.teardown)
    this.teardown()
  }

  // destroy() stellt das <select> auf den Stand beim Aufbau zurück. Damit der
  // Schnappschuss (und das Formular) die aktuelle Auswahl und per JS ersetzte
  // Optionen behält, werden beide vorher gesichert und danach wieder gesetzt.
  teardown() {
    if (!this.tomSelect) return

    const values = [].concat(this.tomSelect.getValue()).map(String)
    const children = [...this.element.children].map((node) => node.cloneNode(true))

    this.element.removeAttribute("aria-hidden")
    this.tomSelect.destroy()
    this.tomSelect = null

    this.element.replaceChildren(...children)
    for (const option of this.element.querySelectorAll("option")) {
      const selected = values.includes(option.value)
      option.selected = selected
      option.toggleAttribute("selected", selected)
    }
  }
}
